import { render } from "./GetawayView.vue?vue&type=template&id=593f2c50&scoped=true"
import script from "./GetawayView.vue?vue&type=script&lang=js"
export * from "./GetawayView.vue?vue&type=script&lang=js"

import "./GetawayView.vue?vue&type=style&index=0&id=593f2c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593f2c50"]])

export default __exports__